import {isEmpty, replace, isMatch, moment, omit, config} from 'helpers';

export function session(state = initial, action) {
  switch (action.type) {

    case 'APP_LAUNCH':
      const start = { offline: !action.online, updateAvailable: false };
      if (!isMatch(state, start)) {
        state = {
          ...state,
          ...start,
        }
      }
      //no break here purposely

    case 'SESSION_TIME_TICK':
      const today = action.timestamp_today;
      const now = moment.unix(action.timestamp);
      const minute = now.startOf('minute').unix();
      const hour = now.startOf('hour').unix();
      if (!isMatch(state, { hour, minute, today })) {
        state = {
          ...state,
          today,
          hour,
          minute,
        }
      }
      return state;

    case 'EMAIL_CHANGED':
      return {
        ...state,
        user: {
          ...state.user,
          email: action.email,
        }
      }

    case 'SESSION_NEW_VERSION_AVAILABLE':
      return {
        ...state,
        updateAvailable: true,
      }

    case 'SESSION_WELCOME_QUIZ':
      return {
        ...state,
        quiz: {
          ...state.quiz,
          ...action.quiz
        }
      }

    case 'SESSION_SET_LOCALE':
      if (state.locale != action.locale) {
        return {
          ...state,
          locale: action.locale,
        }
      }
      return state;

    case 'SESSION_START_PAYMENT':
      return {
        ...state,
        purchasingPlan: action.productCode,
      }

    case 'SESSION_PLAN_UPGRADED':
      return omit(state, 'purchasingPlan');

    case 'SESSION_ONLINE':
    case 'SESSION_OFFLINE':
      return {
        ...state,
        offline: action.type == 'SESSION_OFFLINE',
      }

    case 'SERVER_DATA_RECEIVED':
      if (!isEmpty(action.settings)) {
        const values = {
          token: action.token,
          user: {
            ...state.user,
            email: action.settings.email,
            id: action.settings.userId,
          },
          subscription: {
            free: /free/i.test(action.settings['account-status']),
            plan: replace(action.settings['account-status'], 'Pro', config.proPlan),
            premium: /premium|month|year/i.test(action.settings['account-status']),
            pro: /pro/i.test(action.settings['account-status']),
            mobilePlan: action.settings['account-status-mobile'],
            webPlan: action.settings['account-status-web'],
            paymentMethod: action.settings['payment-method'],
            renewalDate: action.settings['renewal-date'],
          }
        }
        return isMatch(state, values) ? state : { ...state, ...values };
      }
      return state;

    case 'TESTING_DOWNGRADE':
      return {
        ...state,
        subscription: {
          ...state.subscription,
          free: true,
          plan: 'Free'.replace('Pro', config.proPlan),
          premium: false,
          pro: false,
        }
      }

    default:
      return state;

  }

}

const initial = {
  hour: 0,
  locale: 'en',
  minute: 0,
  quiz: {},
  today: 0,
  subscription: {
    free: true,
    mobilePlan: '',
    plan: '',
    premium: false,
    pro: false,
    webPlan: ''
  },
}
